var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIfcGroupReferencedSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #72a341;\n      }\n\n      .cls-2 {\n        fill: #363545;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 30,
    width: 32,
    height: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5,3.15v23.69h22V3.15H5ZM6.69,25.15V4.85h18.62v20.31H6.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.15,14.15v-7.62h-6.77v7.62h6.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.62,14.15v-7.62h-6.77v7.62h6.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.15,23.46v-7.62h-6.77v7.62h6.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.62,23.46v-7.62h-6.77v7.62h6.77Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIfcGroupReferencedSvg);
export default __webpack_public_path__ + "static/media/IFCGroupReferenced_svg.e5c3106c6f864928234308c6c413c648.svg";
export { ForwardRef as ReactComponent };